import { IAddressValidationResponse } from 'src/dataServices/EligibilityService';

const allowedAddressStatuses = new Set(['verified', 'verifiedshippable']);

export const isAddressAllowedByResponseRules = (avsResponse: IAddressValidationResponse): boolean => {
  const normalizedStatus = (avsResponse.status || '').toLowerCase();
  const hasAllowedStatus = allowedAddressStatuses.has(normalizedStatus);
  const secondaryValidationSucceeded = avsResponse.secondary_validation_succeeded === true;

  return hasAllowedStatus || secondaryValidationSucceeded;
};

export const shouldBlockSubmissionOnNon200AvsResponse = (avsResponseRulesEnabled: boolean): boolean => {
  return avsResponseRulesEnabled;
};

export const shouldBlockSubmissionOnAvsException = (avsResponseRulesEnabled: boolean): boolean => {
  return avsResponseRulesEnabled;
};

export const shouldSkipAvsValidation = (addressFieldsDirty: boolean, _region: string): boolean => {
  return !addressFieldsDirty;
};
